/**
 *
 * Loader
 *
 */
import { memo } from 'react';
import './loader.css';
import { Modal } from 'app/components/AlltypeStyledComponent';

interface Props {
  top?: string;
  left?: string;
  right?: string;
  bottom?: string;
  background?: string;
  position?: string;
}

export const Loader = memo((props: Props) => {
  return (
    <Modal
      position={props.position || 'absolute'}
      background={props.background || 'transparent'}
      {...props}
      zindex='1000'
    >
      <div className='lds-ring'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </Modal>
  );
});
